import React from 'react';
import { Link } from 'react-router-dom';
import '../styles.css';

const Footer = () => (
  <footer className="page-footer">
    <div className="container">
      <div className="row">
        <div className="col-md-6 text-center text-md-left">
          <p>© 2025 ABAY Token. All rights reserved.</p>
        </div>
        <div className="col-md-6 text-center text-md-right">
          <a href="https://abaytoken.com" target="_blank" rel="noopener noreferrer" className="footer-link">
            ABAY Web
          </a>
          <span className="mx-2">|</span>
          <a href="https://x.com/abay_token" target="_blank" rel="noopener noreferrer" className="footer-link">
            Twitter
          </a>
          <span className="mx-2">|</span>
          <a href="https://t.me/+bjd8n31u4yg5Yjc0/" target="_blank" rel="noopener noreferrer" className="footer-link">
            Telegram
          </a>
          <span className="mx-2">|</span>
          <Link to="/contact" className="footer-link">
            Contact Us
          </Link>
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;
